import React from "react";
import { SectionNav } from "@/lib";
import { useT } from "../i18n";
import type { EmailQaSection } from "../router";

export function EmailQaNav({ section, owner, testMailEnabled, onChange }: {
  section: EmailQaSection;
  owner: boolean;
  testMailEnabled: boolean;
  onChange: (section: EmailQaSection) => void;
}) {
  const t = useT();
  const sections: EmailQaSection[] = [
    ...(owner ? ["runs", "instructions"] as const : []),
    ...(testMailEnabled ? ["test-mail"] as const : []),
  ];
  return <SectionNav active={section} panelId="email-qa-panel" ariaLabel={t("emailQa.title")}
    entries={sections.map((id) => ({ id, label: t(`emailQa.${id}`) }))}
    onSelect={(id) => onChange(id as EmailQaSection)} />;
}
